export default __webpack_public_path__ + "static/media/alert1.06c25de6.mp3";